import SnapMesinList from "./views/SnapMesinList";
import SnapMesinDetail from "./views/SnapMesinDetail";
import SnapMesinEdit from "./views/SnapMesinEdit";
import SnapMesinTambah from "./views/SnapMesinTambah";
import SnapMesinScanId from "./views/SnapMesinScanId";
import SnapMesinScanSerial from "./views/SnapMesinScanSerial";
import SnapMesinSorting from "./views/SnapMesinSorting";

const requireAuth = {requireAuth: true}

const SnapMesinRoute = [
    {
        path: "/snap_mesin/list",
        name: "ListSnapMesin",
        meta: {
            ...requireAuth,
            accessKey: 'snapBridge.read',
        },
        component: SnapMesinList
    },
    {
        path: "/snap_mesin/detail",
        name: "SnapMesinDetail",
        meta: {
            ...requireAuth,
            accessKey: 'snapBridge.read',
        },
        component: SnapMesinDetail
    },
    {
        path: "/snap_mesin/edit/:idmesin",
        name: "SnapMesinEdit",
        meta: {
            ...requireAuth,
            accessKey: 'snapBridge.update',
        },
        component: SnapMesinEdit
    },
    {
        path: "/snap_mesin/sorting/:idoutlet",
        name: "SnapMesinSorting",
        meta: {
            ...requireAuth,
            accessKey: 'snapBridge.update',
        },
        component: SnapMesinSorting
    },
    {
        path: "/snap_mesin/tambah-mesin/:idoutlet",
        name: "SnapMesinTambah",
        meta: {
            ...requireAuth,
            accessKey: 'snapBridge.create',
        },
        component: SnapMesinTambah,
    },
    {
        path: "/snap_mesin/scan-mesin/:idoutlet",
        name: "SnapMesinScanId",
        meta: {
            ...requireAuth,
            accessKey: 'snapBridge.create',
        },
        component: SnapMesinScanId,
    },
    {
        path: "/snap_mesin/scan-serial/:idoutlet",
        name: "SnapMesinScanSerial",
        meta: {
            ...requireAuth,
            accessKey: 'snapBridge.create',
        },
        component: SnapMesinScanSerial,
    }
]

export default router => {
    router.addRoutes(SnapMesinRoute)
}
